export const askKLueSingleClickPrompts = [
  'How do I win against {COMPETITOR}?',
  'Why would a prospect choose {COMPETITOR}?',
  'How are we different from {COMPETITOR}?',
  'Our top 3 selling points against {COMPETITOR}',
  'What are {COMPETITOR}’s weaknesses?',
  'What questions can I ask to deposition {COMPETITOR}?',
];

export const askKlueWizardFlow = [
  {
    id: 'ask-klue-wizard-flow-1',
    title: 'How do I win my deal against...',
    finalPrompt: `How do I win my deal against {COMPETITOR}? The use case is: {USECASE}. My prospect's objections and priorities are: {OBJECTIONS}. Give a concise summary of the most important differentiators to focus on. Then give me some suggestions of things to ask or say to my prospect.`,
    questions: [
      {
        id: 'ask-klue-wizard-flow-1-1',
        question:
          'Which competitor are you facing in your deal? Select an option or type one:',
        inputType: 'rival',
        promptRef: 'COMPETITOR',
      },
      {
        id: 'ask-klue-wizard-flow-1-2',
        question:
          'I can help with that. What use case(s) are you exploring with your prospect?',
        inputType: 'input',
        promptRef: 'USECASE',
      },
      {
        id: 'ask-klue-wizard-flow-1-3',
        question:
          'Are there any other objections or priorities that you need to address?',
        inputType: 'input',
        promptRef: 'OBJECTIONS',
      },
    ],
  },
  {
    id: 'ask-klue-wizard-flow-2',
    title: 'Where do we compete with...',
    finalPrompt: `Where do we compete with {COMPETITOR}? The use case is: {USECASE}. My prospect's objections and priorities are: {OBJECTIONS}. Give a concise summary of the most important differentiators to focus on. Then give me some suggestions of things to ask or say to my prospect.`,
    questions: [
      {
        id: 'ask-klue-wizard-flow-2-1',
        question:
          'Which competitor are you facing in your deal? Select an option or type one:',
        inputType: 'rival',
        promptRef: 'COMPETITOR',
      },
      {
        id: 'ask-klue-wizard-flow-2-2',
        question:
          'I can help with that. What use case(s) are you exploring with your prospect?',
        inputType: 'input',
        promptRef: 'USECASE',
      },
      {
        id: 'ask-klue-wizard-flow-2-3',
        question:
          'Are there any other objections or priorities that you need to address?',
        inputType: 'input',
        promptRef: 'OBJECTIONS',
      },
    ],
  },
  {
    id: 'ask-klue-wizard-flow-3',
    title: 'What’s new with my competitor...',
    finalPrompt: `What’s new with my competitor {COMPETITOR}? The use case is: {USECASE}. My prospect's objections and priorities are: {OBJECTIONS}. Give a concise summary of the most important differentiators to focus on. Then give me some suggestions of things to ask or say to my prospect.`,
    questions: [
      {
        id: 'ask-klue-wizard-flow-3-1',
        question:
          'Which competitor are you facing in your deal? Select an option or type one:',
        inputType: 'rival',
        promptRef: 'COMPETITOR',
      },
      {
        id: 'ask-klue-wizard-flow-3-2',
        question:
          'I can help with that. What use case(s) are you exploring with your prospect?',
        inputType: 'input',
        promptRef: 'USECASE',
      },
      {
        id: 'ask-klue-wizard-flow-3-3',
        question:
          'Are there any other objections or priorities that you need to address?',
        inputType: 'input',
        promptRef: 'OBJECTIONS',
      },
    ],
  },
];
